<div class="layout-dashboard"></div>
<div class="grid">
    <div class="col-12 xl:col-12">
        <div class="card">
            <div
                class="flex w-full justify-content-between align-items-start"
            >
                <div class="flex flex-column">
                    <h4>{{'PAYMENT_VERIFICATIONS' | translate}}</h4>

                </div>
            </div>
            <div class="spacer"></div>
            <div class="verifications-wrapper">
                <p-table
                [paginator]="true"
                [rows]="15"
                [value]="verifications"
                [rowsPerPageOptions]="[10, 15, 20]"
                responsiveLayout="scroll"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="customerName">
                            {{'CUSTOMER_NAME' | translate}}
                            <p-columnFilter field="customerName" matchMode="contains" display="menu"></p-columnFilter>
                        </th>
                        <th pSortableColumn="customerEmail">
                            {{'EMAIL' | translate}}
                            <p-columnFilter field="customerEmail" matchMode="contains" display="menu"></p-columnFilter>
                        </th>
                        <th pSortableColumn="paymentReference">
                            {{ 'PAYMENT_REFERENCE' | translate }}
                            <p-columnFilter field="paymentReference" matchMode="contains" display="menu"></p-columnFilter>
                        </th>
                        <th pSortableColumn="orderDate">
                            {{'ORDER_DATE' | translate}}
                        </th>
                        <th pSortableColumn="totalAmount">
                            {{'TOTAL_AMOUNT' | translate}}
                        </th>
                        <th pSortableColumn="status">
                            {{'STATUS' | translate}}
                        </th>
                        <th>{{'ACTIONS' | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-verification>
                    <tr>
                        <td>
                            <span class="p-column-title">Customer Name</span>
                            {{verification.customerName}}
                        </td>
                        <td>
                            <span class="p-column-title">Customer Email</span>
                            {{verification.customerEmail}}
                        </td>
                        <td>
                            <span class="p-column-title">Payment Reference</span>
                            {{verification.paymentReference}}
                        </td>
                        <td>
                            <span class="p-column-title">Order Date</span>
                            {{ verification.orderDate | date:'short' }}
                        </td>
                        <td>
                            <span class="p-column-title">Total Amount</span>
                            {{verification.totalAmount | currency : "MZN" + " "}}
                        </td>
                        <td>
                            <span class="p-column-title">Status</span>
                            {{verification.status | translate}}
                        </td>
                        <td>
                            <p-button
                                class="table-button"
                                [pTooltip]="'VIEW_VERIFICATION_DETAILS' | translate"
                                icon="pi pi-info-circle"
                                [rounded]="true"
                                (click)="viewPaymentVerification(verification)"
                                [text]="true"
                                severity="info"
                            />

                        </td>
                    </tr>
                </ng-template>
            </p-table>
            </div>
        </div>
    </div>
</div>
